import classnames from 'classnames'

import {
  CLASS_ALIASES,
  DEFAULT_INPUT_FIELD_HEIGHT,
} from './InputContainer.constants'

import * as styles from './InputContainer.module.css'

/**
 * @property {boolean} [blocked]
 * blocked: behaves like disabled (no clicks, no value changes),
 * but keeps the normal visual style (no opacity change) and
 * shows a "not-allowed" cursor. Unlike "readonly", it should not
 * handle clicks or focus changes at all.
 *
 * @property {boolean} [disabled]
 * disabled: the control is visually and functionally disabled
 *
 * @property {boolean} [readonly]
 * readonly: value cannot be changed but the control can still receive focus
 */
function InputContainer({
  Element = 'div',
  blocked,
  borderless,
  children,
  className,
  disabled,
  focused,
  hasError,
  height = DEFAULT_INPUT_FIELD_HEIGHT,
  readonly,
  ref,
  ...elementProps
}) {
  const inputClassName = classnames(
    styles.InputContainer,
    styles[CLASS_ALIASES[height]],
    {
      [styles.blocked]: blocked,
      [styles.borderless]: borderless,
      [styles.disabled]: disabled,
      [styles.error]: hasError,
      [styles.focused]: focused,
      [styles.readonly]: readonly,
      [styles.regular]: !borderless,
    },
    className
  )

  return (
    <div className={styles.inputWrapper}>
      {disabled ? <div className={styles.disabledOverlay} /> : null}
      <Element {...elementProps} className={inputClassName} ref={ref}>
        {children}
      </Element>
    </div>
  )
}

export default InputContainer
